import { get, post } from '../utils/http/axiosInstance';

// AI Agent 开始接口
export const aiAgentRun = (params) => {
  return post('/api/openapi/aiagent/run', params);
};
export const getDelay = (params) => {
  return post('/api/openapi/aiagent/reminder/list', params);
};
// 根据公司id查询提醒回复信息
export const getReminder = (companyId, language) => {
  return get(`/api/openapi/message/queryMessageRemindingList?companyId=${companyId}&language=${language}`);
};
